import {Box, Grid} from "@mui/material";
import commonStyles from "../commonStyles";
import CompletedIcon from '@mui/icons-material/CheckCircleOutline';
import InProgressIcon from '@mui/icons-material/QueryBuilder';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import {Fragment} from "react";
import {formatToDate} from "../../../../../../_helpers";

function DisableProcessTitle({disableProcess}) {
    return (<Box component={'h5'}>Disable triggered at {formatToDate(disableProcess.dateCreated)}</Box>);
}

function DisableStatus({disableProcess}) {
    switch (disableProcess.status) {
        case 'COMPLETED':
            return <CompletedIcon sx={styles.completedStatusIcon} />;
        case 'IN_PROGRESS':
            return <InProgressIcon sx={styles.inProgressStatusIcon} />;
        case 'FAILED':
            return <ErrorIcon sx={styles.failedStatusIcon} />;
        default:
            return <Fragment/>;

    }
}

export default function DisableProcessSummary({disableProcess}) {
    return (
        <Grid container columns={2}>
            <Grid item xs={4} md={1} sx={styles.nameContainer}>
                <DisableProcessTitle disableProcess={disableProcess}/>
            </Grid>
            <Grid item xs={4} md={1} sx={styles.statusContainer}>
                <Box compontent={'h5'} sx={styles.statusLabel}>Status</Box>
                <DisableStatus disableProcess={disableProcess}/>
            </Grid>
        </Grid>
    );
}

const styles = {
    nameContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    statusLabel: {
        ...commonStyles.labelMedium,
        padding: 1,
    },
    inProgressStatusIcon: {
        color: '#003300'
    },
    completedStatusIcon: {
        color: '#003300'
    },
    failedStatusIcon: {
        color: '#770000'
    },
    statusContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        paddingRight: 4
    }
};